import { takeEvery, put, call } from "redux-saga/effects";
import { types } from "../reducers/forms";
import { FormsService } from '../../services';
import ErrorFormat from '../../helpers/FormatErrors';

function* getForms({ value }) {
  try {
    const { data } = yield call(() => FormsService.get(value));
    if (data) {
      const forms = {};
      forms[value.view] = data;
      yield put({
        type: types.GET_FORMS_SUCCEDDED,
        value: forms,
      });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.GET_FORMS_FAILED,
        value: errors,
      });
    }
  }
}

function* getDocForms() {
  try {
    const { data } = yield call(() => FormsService.getDoc());
    if (data) {
      const forms = {};
      forms['doc'] = data.form;
      yield put({
        type: types.GET_DOC_FORMS_SUCCEDDED,
        value: forms,
      });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.GET_FORMS_FAILED,
        value: errors,
      });
    }
  }
}

function* getForm() {
  try {
    const { data } = yield call(() => FormsService.getValue());
    if (data) {
      yield put({
        type: types.GET_FORM_SUCCEDDED,
        value: data,
      });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.GET_FORM_FAILED,
        value: errors,
      });
    }
  }
}

function* submitForm({ value }) {
  try {
    const { data } = yield call(() => FormsService.submit(value));
    if (data) {
      yield put({
        type: types.SUBMIT_SUCCEDDED,
        value: data,
      });
    }
  } catch (e) {
    const errors = ErrorFormat.format(e.response.data.errors);
    if (errors) {
      yield put({
        type: types.GET_FORMS_FAILED,
        value: errors,
      });
    }
  }
}

export default function* init() {
  yield takeEvery(types.GET_FORMS, getForms);
  yield takeEvery(types.GET_FORM, getForm);
  yield takeEvery(types.SUBMIT_REQUESTED, submitForm);
  yield takeEvery(types.GET_DOC_FORMS, getDocForms);
}
